import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isUndefined } from 'lodash';

/**
 * ScheduleExport
 *
 * @TODO Needs description.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const ScheduleExport = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': `/action-paths/${thePayload?.actionPathId}/extracts`,
      },
      method: 'POST',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    if (isUndefined(thePayload?.maxRecords)) {
      requestArgs.data = {
        maxRecords: 1000000,
      };
    } else {
      requestArgs.data = {
        maxRecords: thePayload?.maxRecords,
      };
    }

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error('src/entities/RiskRecord/api/requests/mutations/ScheduleExport.js -> ScheduleExport()', false, error);

    throw error;
  }
};
